export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass — прямые трансляции игр NBA | NBA.com',
	seo_meta_desc_leaguepass: 'Смотрите игры NBA в прямом эфире и в записи в рамках подписки League Pass. Войдите в свою учетную запись здесь.',
	seo_meta_keywords_leaguepass: 'Видео НБА, ключевые моменты НБА, баскетбольные видео, лучшие комбинации, данки, репортажи',
	seo_meta_title_featured: 'Прямые трансляции игр NBA и яркие моменты | NBA.com',
	seo_meta_desc_featured: 'Смотрите бесплатно видеоролики об NBA, новости и аналитические материалы. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV — прямые трансляции игр и круглосуточное вещание | NBA.com',
	seo_meta_desc_nbatv: 'Смотрите легендарные матчи NBA на NBA TV. Кроме того, вам будут доступны игры NBA TV в прямом эфире, студийные передачи и аналитические материалы.',
	seo_meta_keywords_nbatv: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',
	seo_meta_title_classicgames: 'Прямые трансляции студийных передач NBA TV и многое другое | NBA.com',
	seo_meta_desc_classicgames: 'Смотрите легендарные матчи NBA на NBA TV. Кроме того, вам будут доступны игры NBA TV в прямом эфире, студийные передачи и аналитические материалы.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Прямые трансляции | NBA.com',
	seo_meta_title_videolist: 'Прямая трансляция {0} | NBA.com',
	seo_meta_desc_videolist: 'Смотрите видео {0} здесь. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_title_videolist_show: 'Прямая трансляция {0} на NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Смотрите {0} здесь. Кроме того, вам будут доступны прямые трансляции игр NBA TV, классические игры и аналитические материалы.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Прямая трансляция {0} | NBA.com',
	seo_meta_desc_videolist_feed: 'Смотрите видео {0} здесь. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Прямые трансляции студийных передач NBA TV и многое другое | NBA.com',
	seo_meta_desc_shows: 'Смотрите свежие выпуски передач NBA TV и записи старых эпизодов. Кроме того, вам будут доступны прямые трансляции игр NBA TV, классические игры и аналитические материалы.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Главная | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Каналы | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Канал | NBA.com',
	seo_meta_pre_title_categories: 'Категории | NBA.com',
	seo_meta_title_categories: 'Категории | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Категория | NBA.com',
	seo_meta_title_category: 'Категория | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Прямые видеотрансляции | NBA.com',
	seo_meta_pre_title_event: 'Прямые трансляции событий | NBA.com',
	seo_meta_title_events: 'События | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Прямая трансляция {0} | NBA.com',
	seo_meta_desc_event: 'Смотрите {0} здесь. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Поиск | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Страница не найдена | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Прямые трансляции игр | NBA.com',
	seo_meta_title_game: 'Прямая трансляция {0} | NBA.com',
	seo_meta_desc_game: 'Смотрите {0} здесь. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Прямая трансляция {0} | NBA.com',
	seo_meta_desc_video: 'Смотрите {0} здесь. Также рекомендуем ознакомиться с подписками NBA TV и League Pass, позволяющими смотреть игры в прямом эфире на ваших любимых устройствах.',
	seo_meta_keywords_video: 'Видео НБА, ключевые моменты НБА, баскетбольные видео, лучшие комбинации, данки, репортажи',
	seo_meta_title_episode: 'Прямая трансляция {0} с NBA TV | NBA.com',
	seo_meta_desc_episode: 'Смотрите {0} здесь. Кроме того, вам будут доступны прямые трансляции игр NBA TV, классические игры и аналитические материалы.',
	seo_meta_keywords_episode: 'Видео НБА, ключевые моменты НБА, баскетбольные видео, лучшие комбинации, данки, репортажи',
	seo_meta_title_channel: 'Прямой эфир NBA TV | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live — это непрерывный стрим на канале NBA TV в течение 24 часов в сутки: прямые трансляции и показ игр из архива НБА каждую неделю, студийные программы и комментарии аналитиков',
	seo_meta_keywords_channel: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',
	seo_meta_title_tvguide: 'Расписание прямых трансляций NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Узнайте, когда вы сможете посмотреть игры NBA TV и студийные передачи в прямом эфире на вашем любимом устройстве. Кроме того, вам будут доступны записи студийных передач и аналитические материалы.',
	seo_meta_keywords_tvguide: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',

	// Common
	timezone: 'восточное время (ET)',
	default_feed_error_message: 'Что-то пошло не так, в настоящее время контент недоступен. Повторите попытку через некоторое время.',
	watch_in_app: 'СМОТРЕТЬ В ПРИЛОЖЕНИИ NBA',
	ad_blocked_message: 'Обнаружен блокировщик рекламы. Сайт NBA.com существует за счет рекламы, поэтому просим отключить блокировку рекламы, чтобы и дальше наслаждаться высококачественным контентом.',

	// Item
	no_content: 'Контент отсутствует',
	see_more: 'Подробнее',
	now_playing: 'СЕЙЧАС ВОСПРОИЗВОДИТСЯ',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'Пакет League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Вы достигли максимального количества избранных видео. Пожалуйста, удалите некоторые из них, прежде чем добавлять новые.',
	item_live: 'Прямой эфир:',
	add_favourite_title: 'ДОБАВИТЬ В ИЗБРАННОЕ',
	remove_favourite_title: 'УДАЛИТЬ ИЗ ИЗБРАННОГО',
	// Channel: Schedule
	p_channel_live: 'ПРЯМОЙ ЭФИР',
	p_channel_schedule_title: 'Расписание NBA TV',
	p_channel_schedule_watch: 'Смотреть',
	p_channel_live24x7_title: 'NBA TV круглосуточно',
	p_channel_live24x7_see_full_schedule: 'См. полное расписание',
	p_channel_live24x7_up_next: 'далее в программе',
	p_channel_live24x7_on_demand: 'NBA TV: по запросу',
	p_channel_live24x7_collection: 'Коллекция',
	p_channel_live24x7_demand_1_logo_text: 'оригинальные передачи',
	p_channel_live24x7_demand_1_show_name: 'Передачи NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Оригинальные передачи NBA TV, в том числе Shaqtin’ a Fool, Beyond the Paint, Game Time и Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Классические игры',
	p_channel_live24x7_demand_2_show_name: 'NBA | Классические игры',
	p_channel_live24x7_demand_2_show_desc: 'Смотрите классические игры полностью, в том числе все финальные матчи с 2000 года, исторические моменты лиг и выступления легендарных игроков.',

	// Channel: Clips
	p_channel_error_msg: 'Пока недоступно',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Передачи',

	// NBA TV Shows:
	p_nba_tv_shows: 'Передачи NBA TV',
	p_nba_tv_no_access_title: 'NBA круглосуточно: оставайтесь в курсе событий благодаря анализу игр, студийному анализу, оригинальным программам и другому эксклюзивному контенту!',
	p_nba_tv_no_access_desc: 'Смотрите игры в прямом эфире, а также записи передач и классических игр.',
	p_nba_tv_no_access_note: 'Могут действовать ограничения на показ по ТВ',

	// tv show item
	tv_show_item_latest_episode: 'последний выпуск',
	tv_show_item_no_latest_episode: 'нет последнего выпуска',
	see_all: 'Посмотреть все',
	// header
	header_menu_watch: 'Смотреть',
	header_menu_featured: 'ЛУЧШЕЕ',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'Пакет League Pass',

	// search
	players: 'Игроки',
	videos: 'Видео',
	teams: 'Команды',
	most_searched: 'САМЫЕ ПОПУЛЯРНЫЕ',
	no_result: 'Нет данных',
	search_filter_type_most_relevant: 'Самые релевантные',
	search_filter_type_most_viewed: 'Самые просматриваемые',
	search_filter_type_most_recent: 'Новейшие',
	search_filter_type_last_30_days: 'За последние 30 дней',
	search_filter_type_last_6_months: 'За последние 6 месяцев',
	search_result_label: 'Результаты поиска для \'{keyword}\'',
	search_result_info: 'Показать все результаты для {keyword}',
	search_placeholder: 'Поиск в видеотеке',
	load_more: 'Загрузить еще...',

	// button
	button_subscribe: 'Подписаться',
	button_sign_in: 'Вход',
	button_tv_provider: 'Выберите ТВ-провайдера',

	// league page
	p_league_pass_no_access_title: 'Смотрите игры в прямом эфире или в режиме повтора на любом устройстве, в том числе на компьютере, смартфоне и телевизоре!',
	p_league_pass_no_access_desc: 'Ваш пропуск в самую гущу событий: смотрите матчи всей лиги или только своей любимой команды, выберите конкретную игру и ознакомьтесь с другими вариантами.',
	p_league_pass_no_access_note: 'Действуют условия',

	// Video
	category_title: 'Видео',
	p_video_playlist_title: 'Список воспроизведения',
	p_video_episode_text: 'Эпизод',
	p_no_access_league_pass_title: 'Разблокируйте NBA League Pass, чтобы получить доступ к следующему контенту:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Ваш пропуск в самую гущу событий: смотрите матчи всей лиги или только своей любимой команды, выберите конкретную игру и ознакомьтесь с другими вариантами.',
	p_no_access_league_pass_terms: 'Действуют условия',
	p_no_access_league_pass_geo_desc: 'Согласно данным о вашем местоположении, вы не можете просматривать эту игру в NBA League Pass и NBA TV. Архив этих игр будет доступен подписчикам NBA League Pass через 3 дня после трансляции. Ознакомьтесь с расписанием местных теле- и радиовещательных компаний, чтобы узнать, по каким каналам транслируются спортивные передачи в вашем регионе.',
	p_no_access_league_pass_not_found_desc: 'К сожалению, запрошенное видео не найдено.',
	p_no_access_event_geo_desc: 'Данная трансляция недоступна в США и Канаде. Посмотреть трансляцию можно на телеканалах ESPN в США и TSN или Sportsnet в Канаде.',
	p_no_access_event_not_found_desc: 'К сожалению, запрошенное событие не найдено.',
	p_no_access_nba_tv_title: 'Разблокируйте NBA TV, чтобы получить доступ к следующему контенту:',
	p_no_access_nba_tv_desc: 'Смотрите игры в прямом эфире, а также записи передач и классических игр.',
	p_no_access_nba_tv_terms: 'Действуют условия',
	p_no_access_nba_tv_geo_desc: 'Согласно данным о вашем местоположении, вы не можете просматривать эту игру в NBA League Pass и NBA TV. Архив этих игр будет доступен подписчикам NBA League Pass через 3 дня после трансляции. Ознакомьтесь с расписанием местных теле- и радиовещательных компаний, чтобы узнать, по каким каналам транслируются спортивные передачи в вашем регионе.',
	p_no_access_nba_tv_not_found_desc: 'К сожалению, запрошенный канал не найден.',
	p_no_access_up_next: 'Далее в программе:',
	p_video_completed_title: 'Список воспроизведения завершен',
	p_video_completed_desc: 'Вернитесь, чтобы просмотреть все списки воспроизведения и выбрать следующий',
	p_video_share_to: 'Поделиться с:',
	p_video_more_to_watch: 'Дополнительный контент:',

	// Event
	p_event_section_title: 'МЕРОПРИЯТИЕ',
	p_event_playlist_title: 'Список воспроизведения',
	p_event_button_watch: 'Смотреть',
	p_event_button_listen: 'Слушать',
	p_event_button_ticket: 'Билет',

	// notfound page
	notfound: 'К сожалению, страница не найдена.',
	notfound_desc: 'Пожалуйста, проверьте правильность написания URL<br/> или попробуйте воспользоваться навигацией по сайту или поиском.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Для вашей учетной записи NBA League Pass ведется слишком много потоковых трансляций. Нажмите кнопку «Продолжить», чтобы возобновить просмотр на данном устройстве.',
	modal_pcm_custom: 'Продолжить',
	modal_pcm_close: 'Отмена',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Воспроизведение этого видео на вашем устройстве невозможно. Нажмите <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ЗДЕСЬ</a> для получения поддержки.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ОК',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Осталось времени:',
	freesample_notice_title: 'Вам предоставлено {0} минут доступа',
	freesample_notice_desc: 'Подпишитесь на полноценный пакет League Pass, чтобы продолжить смотреть игры по истечении 10 {0} минут.',
	freesample_notice_subscribe_button: 'Подписаться',
	freesample_notice_cancel_button: 'Отмена в любой момент',
	freesample_popup_title: 'ВРЕМЯ ДОСТУПА ИСТЕКЛО',
	freesample_popup_subtitle: 'Подпишитесь на League Pass, чтобы смотреть другие захватывающие игры NBA.',
	freesample_popup_link: 'Подробнее',
	freesample_popup_get_minutes_button: 'ПОЛУЧИТЬ {0}  МИНУТ',

	// Video list
	reg_required_desc: 'Для просмотра этого контента необходимо войти в систему',
	favorite_teams_title: 'Любимые команды',
	bookmarked_title: 'Сохранено',
	watch_history_title: 'Продолжить просмотр',
	game_schedule_title: 'Расписание игр',
	recommended_title: 'Рекомендуемые',
	season_text: 'Сезон',

	// profile page
	section_information_title: 'Мои данные',
	section_information_desc: 'Обновить персональные данные',
	section_information_email: 'Адрес электронной почты',
	section_information_email_update: 'Обновить адрес эл. почты',
	section_information_password: 'Пароль',
	section_information_password_update: 'Сменить пароль',
	section_information_social: 'Привязка к социальным сетям',
	section_information_nosocial_message: 'У вас нет привязанных аккаунтов.',
	section_information_firstname: 'Имя',
	section_information_lastname: 'Фамилия',
	section_information_birth: 'Дата рождения',
	section_information_country: 'Страна/Регион',
	section_information_postalcode: 'Почтовый индекс',
	section_information_edit: 'Редактировать',
	section_tv_provider_title: 'Мой ТВ-провайдер',
	section_tv_provider_desc: 'Получите доступ к играм и трансляциям в прямом эфире через вашего ТВ-провайдера.',
	section_tv_provider_faq: 'Часто задаваемые вопросы о ТВ-провайдерах',
	section_tv_provider_sign_out: 'Выход',
	section_tv_provider_sign_in: 'Вход через ТВ-провайдера',
	section_fantasy_title: 'Фэнтези',
	section_fantasy_desc: 'Просмотреть вымышленные данные вашей учетной записи',
	section_fantasy_displayname: 'Отображаемое имя',
	section_marketing_title: 'Настройки эл. почты',
	section_marketing_desc: 'Просмотреть ваши предпочтения в отношении маркетинговых материалов и конфиденциальности',
	section_marketing_newsletters: 'Информационная рассылка',
	section_marketing_message: 'Рекламные и информационные сообщения NBA',
	section_marketing_newsletters_desc_1: 'Новости NBA, отправляемые ежедневно на ваш адрес эл. почты',
	section_marketing_newsletters_desc_2: 'Новости и другие материалы Джи-Лиги NBA из официальных источников низшей лиги NBA',
	section_marketing_newsletters_desc_3: 'Новости и другие материалы Юниорской лиги NBA из официальных источников программы развития молодежного баскетбола',
	section_marketing_newsletters_desc_4: 'Новейшие функции приложения NBA, а также обновления и предложения League Pass',
	section_marketing_newsletters_desc_5: 'Билеты по льготным ценам, предложения партнеров, события и скидки на товары с фирменной символикой NBA',
	section_marketing_newsletters_desc_6: 'Отобранные вручную новости и контент NBA с еженедельной доставкой на ваш адрес эл. почты',
	section_marketing_newsletters_desc_7: 'Новости и предложения WNBA и партнеров WNBA',
	section_marketing_personal_title: 'Мои персональные данные',
	section_marketing_personal_desc: 'Я разрешаю NBA использовать мои личные данные для отправки мне сообщений и рекламной информации о продуктах и инициативах NBA и партнеров NBA.',
	section_marketing_update_button: 'Обновить маркетинговые предпочтения',
	section_marketing_update_success: 'Настройки обновлены.',
	section_ccpa_title: 'Не продавать мои персональные данные',

	// profile edit modal
	email_modal_title: 'обновить адрес эл. почты',
	email_modal_new_email_label: 'новый адрес эл. почты',
	email_modal_update: 'Обновить',
	email_modal_cancel: 'Отмена',
	password_modal_title: 'Сменить пароль',
	password_modal_current_label: 'Текущий пароль:',
	password_modal_new_label: 'Новый пароль:',
	password_modal_confirm_label: 'Подтвердите пароль',
	password_modal_update: 'Обновить',
	password_modal_cancel: 'Отмена',
	personal_modal_title: 'обновить персональные данные',
	personal_modal_email: 'Адрес электронной почты',
	personal_modal_password: 'Пароль',
	personal_modal_birth: 'Дата рождения',
	personal_modal_social: 'Привязка к социальным сетям',
	personal_modal_firstname: 'Имя',
	personal_modal_lastname: 'Фамилия',
	personal_modal_country: 'Страна/Регион',
	personal_modal_postalcode: 'Почтовый индекс',
	personal_modal_zipcode: 'Почтовый индекс',
	personal_modal_postalcode_invalid_message: 'Укажите действительный почтовый индекс',
	personal_modal_zipcode_invalid_message: 'Укажите действительный почтовый индекс',
	personal_modal_update: 'Обновить',
	personal_modal_cancel: 'Отмена',

	// payflow
	payflow_profile_name: 'Имя:',
	payflow_profile_email: 'Адрес электронной почты',

	// account page
	header_menu_account_my_account: 'Мой аккаунт',
	header_menu_account_manage_account: 'Управление учетной записью',
	header_menu_account_favorite_teams: 'Любимые команды',
	header_menu_account_favorite_players: 'Любимые игроки',
	header_menu_account_viewing_history: 'История просмотров',
};
